import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('core-details-page', {
    attrs: {
      "fetch-item": _vm.fetchItem,
      "external-fetch-params": {
        itemId: _vm.itemId
      },
      "headline": _vm.headline,
      "subtitle": _vm.subtitle,
      "tabs": _vm.tabs,
      "isFormValid": _vm.formValidCompute,
      "edit-mode": _vm.isDeviceTemplateManager,
      "parent-href": "/device-templates",
      "save-item": _vm.saveItem,
      "templateInformation": _vm.templateInformation
    },
    on: {
      "item-change-state": newState => _vm.templateInformation.templateIsChanged = newState
    },
    scopedSlots: _vm._u([{
      key: "deviceMetaInformation",
      fn: function (slotProps) {
        return [_c('core-device-template-edit-device-information', {
          attrs: {
            "template": slotProps.item,
            "isProductiveVersion": slotProps.item.isProductiveVersion,
            "account": _vm.account,
            "readonly": !_vm.isDeviceTemplateManager
          },
          on: {
            "formValidated": _vm.handleDeviceMetaFormValidated
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "templateMetaInformation",
      fn: function (slotProps) {
        return [_c('core-device-template-edit-template-information', {
          attrs: {
            "template": slotProps.item,
            "isProductiveVersion": slotProps.item.isProductiveVersion,
            "account": _vm.account,
            "readonly": !_vm.isDeviceTemplateManager
          },
          on: {
            "formValidated": _vm.handleTemplateMetaFormValidated
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "dataStates",
      fn: function (slotProps) {
        return [_c('core-device-template-data-states', {
          attrs: {
            "template": slotProps.item,
            "isProductiveVersion": slotProps.item.isProductiveVersion,
            "account": _vm.account,
            "readonly": !_vm.isDeviceTemplateManager,
            "templateInformation": _vm.templateInformation
          },
          on: {
            "formValidated": _vm.handleDataStatesFormValidated,
            "update-unsaved-changes": _vm.updateUnsavedChanges
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "ruleEditor",
      fn: function (slotProps) {
        return [_c('core-device-template-rule-editor', {
          attrs: {
            "template": slotProps.item,
            "readonly": !_vm.isDeviceTemplateManager,
            "isProductiveVersion": slotProps.item.isProductiveVersion
          },
          on: {
            "update-unsaved-changes": _vm.updateUnsavedChanges
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "dataRouting",
      fn: function (slotProps) {
        return [_c('core-device-template-data-routing', {
          attrs: {
            "template": slotProps.item,
            "readonly": !_vm.isDeviceTemplateManager,
            "isProductiveVersion": slotProps.item.isProductiveVersion
          },
          model: {
            value: slotProps.item,
            callback: function ($$v) {
              _vm.$set(slotProps, "item", $$v);
            },
            expression: "slotProps.item"
          }
        })];
      }
    }, {
      key: "linkedDevices",
      fn: function () {
        return [_vm.linkedDevicesFetchError ? _c(VAlert, {
          staticClass: "mb-4",
          attrs: {
            "type": "error",
            "border": "left",
            "colored-border": "",
            "elevation": "1",
            "icon": false
          }
        }, [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('div', {
          staticClass: "d-flex align-center mr-3 flex-shrink-0",
          staticStyle: {
            "align-self": "stretch"
          }
        }, [_c(VIcon, {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("fal fa-exclamation-triangle")])], 1), _c('div', {
          staticClass: "flex-grow-1 d-flex flex-column justify-center"
        }, [_c('div', {
          staticClass: "font-weight-bold black--text"
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Core.DetailsPage.alerts.fetchError.title')) + "\n            ")]), _c('i', {
          staticClass: "black--text"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Error.NETWORK_ERROR')))])]), _c(VBtn, {
          staticClass: "flex-shrink-0",
          attrs: {
            "text": "",
            "small": "",
            "color": _vm.color
          },
          on: {
            "click": _vm.retryLinkedDevicesFetch
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Core.DetailsPage.alerts.fetchError.refetchBtn')) + "\n          ")])], 1)]) : _vm._e(), _c('core-virtual-device-list', {
          ref: "linkedDevicesList",
          attrs: {
            "searchTypes": _vm.searchTypes,
            "predefined-search": _vm.linkedDevicesPredefinedSearch,
            "favourite-filter-enabled": false,
            "restoreFilter": false
          },
          on: {
            "load-items": _vm.handleLinkedDevicesLoaded,
            "load-items-error": _vm.handleLinkedDevicesLoadError
          }
        })];
      },
      proxy: true
    }, {
      key: "unsyncedChanges",
      fn: function (slotProps) {
        return [_c('core-device-template-unsynced-changes', {
          attrs: {
            "template": slotProps.item,
            "linkedDevicesTotalCount": _vm.templateInformation.linkedDevicesTotalCount,
            "hasUnsavedChanges": _vm.templateInformation.templateIsChanged,
            "unsyncedChanges": _vm.templateInformation.unsyncedChanges,
            "readonly": !_vm.isDeviceTemplateManager
          },
          on: {
            "save-and-synchronise": _vm.updateUnsyncedChanges
          }
        })];
      }
    }, {
      key: "healthStateExpertModeMetricCodeEditor",
      fn: function (slotProps) {
        return [_c('code', [_vm._v("function (params) {")]), _c('codemirror', {
          staticClass: "elevation-3",
          attrs: {
            "value": _vm.get(slotProps.item, slotProps.field.key),
            "options": {
              ..._vm.cmOptions,
              readOnly: !_vm.isDeviceTemplateManager
            }
          },
          on: {
            "input": slotProps.emitInput
          }
        }), _c('code', [_vm._v("}")])];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };